import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonGuard  {
  canActivate(): boolean {
    return true;
  }

  hasPermissions() {
    return localStorage.getItem('user_role')?.includes("common");
  }
}